export interface GraphQLResponseBody {
  data: any
  errors: GraphQLErrorBody[]
}

export interface GraphQLErrorBody {
  code: GraphQLErrorCode
  message: string
  path: string[]
}

export enum GraphQLErrorCode {
  Unauthorized = 'Unauthorized',
  Forbidden = 'Forbidden',
  BadRequest = 'BadRequest',
  InternalServerError = 'InternalServerError'
}
